import script from "./CrudApp.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudApp.vue?vue&type=script&setup=true&lang=js"

import "./CrudApp.vue?vue&type=style&index=0&id=1cb973dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cb973dd"]])

export default __exports__